export default "__VITE_ASSET__45da2d99__"